import React from 'react'
import styles from './NoDesktop.module.scss'
import snake from '../../assets/Snake.svg'
import optionsStore from '../../zustand/optionsStore'

const NoDesktop = () => {
    const lang = optionsStore(state => state.language)
    return (
        <div className={styles.wrapper}>
            <img src={snake} alt="Snake" />
            <h1>{lang.noDesktop.line1}</h1>
            <h2>{lang.noDesktop.line2}</h2>
        </div>
    )
}

export default NoDesktop